// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi?societaId&dipendenteId&stato&q',
    requestBody: null,
    response: '{success:true,data:[{id,dispositivo,dipendente,consegnato,dataAssegnazione,dataRestituzione,noteRestituzione,note,verbaleFileName}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi/dipendenti-lista?societaId&q',
    requestBody: null,
    response: '{success:true,data:[{id,nome,cognome,mansione,stato}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/dispositivi-aziendali?societaId&stato&q',
    requestBody: null,
    response: '{success:true,data:[{id,codiceMatricola,tipologia,marca,modello,stato}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id',
    requestBody: '{dataAssegnazione,consegnatoId,note}',
    response: '{success:true,data:{...}}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/assegnazioni-dispositivi',
    requestBody: '{societaId,dispositivoId,dipendenteId,dataAssegnazione,consegnatoId,note}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/verbale',
    requestBody: '{verbale:file}',
    response: '{success:true,data:{verbaleGcsPath,verbaleFileName}}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/verbale',
    requestBody: '{verbale:file}',
    response: '{success:true,data:{verbaleGcsPath,verbaleFileName}}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/verbale',
    requestBody: null,
    response: '[PDF stream]'
  },
  {
    method: 'PATCH',
    endpoint: '/api/hr/assegnazioni-dispositivi/:id/restituzione',
    requestBody: '{dataRestituzione,noteRestituzione}',
    response: '{success:true,data:{dataRestituzione,noteRestituzione}}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/assegnazioni-dispositivi/dipendente/:dipendenteId?societaId',
    requestBody: null,
    response: '{success:true,data:{dipendente,assegnazioni}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
